import React from 'react';

import {
    ajax, plainDate, 
     downloadFilePost, downloadOrderLabels,
    deleteOrders, showPopup,
    getNavigation,
    loadAutocompleteCountries,
    autoCompleteForeignCitiesForCountry,
    loadUPSProvinceCodes,
    UPSCourier, USCountryCode, canadaCountryCode, ProfileLevels
} from '../components/globals';
import { Languages } from '../components/languages';
import { Roles } from '../auth/rolesPermissions'
import {
    InputColumn,
} from '../components/utilities';
import {
    emptyValidation,
    validate
} from '../components/validate';

import { UIFilterPanel, PageTitle, UIDataTable, UIDownload, UIPopup, UIInput, UIButton, UICheckbox, UISelect } from '../components/guiElements';
import { FieldProps } from '../components/fieldProps';
import { v4 as uuidv4 } from 'uuid';



export class DiscardedOrdersList extends React.Component {
    constructor(props) {
        super(props);

        this.getData = this.getData.bind(this);
        this.listClick = this.listClick.bind(this);
        this.listChange = this.listChange.bind(this);
        this.modalChange = this.modalChange.bind(this);
        this.removeAction = this.removeAction.bind(this);
        this.changeAction = this.changeAction.bind(this);
        this.filtersChange = this.filtersChange.bind(this);

        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        // this.onAutocompleteCountrySelected = this.onAutocompleteCountrySelected.bind(this);
        

        this.onAutocompleteCityChange = this.onAutocompleteCityChange.bind(this);
        this.onAutocompleteCitySelected = this.onAutocompleteCitySelected.bind(this);
        
        this.le = Languages.DiscardedOrdersList[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.header = [
            {
                generic: { manage: 0, name: 'orderNo', width: 14, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'date', width: 12, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'courier', width: 10, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },{
                generic: { manage: 0, name: 'customer', width: 14, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'reason', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[4] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 1, default: null, name: 'actions', width: 13, change: null, click: this.listClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[5] },
                element: { type: 'buttons-group', colClass: null, itemClass: ['modify', 'modify delete'], options: this.le.listButtons }
            }];

        if (this.uc && this.uc.userRole === Roles.READONLY) {
            this.header.pop(); //remove actions
        }

        this.listKey = 0;
        const defaultManager = this.header.filter((el) => (el.generic.manage>0)).map((el) => (el.generic.default));


        this.configs = {
            filters: {
                orderNum: { type: "text", width: "20%" },
                recipient: { type: "text", width: "20%" }
            }
        };

        let filters = {};
        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });
        this.appliedFilters = filters;

        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.state = {
            entries: [],
            orders: [],
            navigation: navigation,
            managers: Array(props.entries.length + 1).fill().map((el) => (defaultManager.slice())),
            modalType: 0,
            modalReference: null,
            modalColumn: {
                id: 'C1',
                rowsize: 30,
                itemunit: 10,
                items: [
                    { id: 'name', mandatory: true, size: 15, text: this.le.update.inputs[0], type: 'text', value: '', class: null, validate: emptyValidation },
                    { id: 'surname', mandatory: false, size: 15, text: this.le.update.inputs[1], type: 'text', value: '', class: null,},
                    { id: 'address', mandatory: true, size: 20, text: this.le.update.inputs[2], type: 'text', value: '', class: null, validate: emptyValidation},
                    { id: 'houseNo', mandatory: false, size: 10, text: this.le.update.inputs[3], type: 'text', value: '', class: null},
                    {
                        id: 'country',
                        mandatory: true,
                        size: 30,
                        text: this.le.update.inputs[4], 
                        maxLength: FieldProps.getFieldProp('country', 'maxLength'),
                        type: 'selectField', 
                        options: [],
                        value: '',
                        validate: emptyValidation
                    },
                    { id: 'city', mandatory: true, size: 30, text: this.le.update.inputs[5], type: 'autocomplete', value: '', class: null, 
                        validate: emptyValidation,
                        disabled: false,
                        options: [],
                        maxLength: FieldProps.getFieldProp('city', 'maxLength')
                    },
                    { 
                        id: 'province', mandatory: true,
                        size: 20,
                        text: this.le.update.inputs[6],
                        type: 'text',
                        value: '',
                        class: null,
                        options: [],
                        validate: emptyValidation, disabled: false,
                    },
                    { 
                        id: 'zip', mandatory: true, size: 10, text: this.le.update.inputs[7], type: 'text', value: '', class: null, validate: emptyValidation, disabled: true
                    },
                    { id: 'note', mandatory: false, size: 10, text: this.le.update.inputs[11], type: 'text', value: '', class: null}
                ]
            },
            countries: [],
            countryCode: "",
            newCanadaProvinceCodes: [],
            newUSProvinceCodes: [],
            carrierName: "",
            suggestedCountry: [],
            suggestedCity:[],
            filters
        };

        // indexes remapping entries with the input boxes of modal box                             
        this.modalDataMap = [[0, 5], [1, 6], [2, 7], [3, 8], [4, 9], [5, 10], [6, 11], [7, 12]];
    }

    componentDidMount() {
        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage>0 ? mngIdx++ : entIdx++) }));


        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.getData(navigation);

        loadAutocompleteCountries(this.uc.jwtToken, (countries) => {

            this.setState({
                countries
            });
        },
        ko => { },
        this);
        
        loadUPSProvinceCodes(canadaCountryCode, this.uc.jwtToken,
            canadaProvinceCodes => {
                const modifiedCanadaProvinceCodes = ["", ...canadaProvinceCodes];
                const newCanadaProvinceCodes = modifiedCanadaProvinceCodes.map((provinceCode) => {
                   return  {
                        text: provinceCode,
                        value: provinceCode
                    }
                });
                this.setState({
                    newCanadaProvinceCodes
                })
            },
            ko => { },
            this
        );

        loadUPSProvinceCodes(USCountryCode, this.uc.jwtToken,
            usProvinceCodes => {
                const modifiedUSProvinceCodes = ["", ...usProvinceCodes];
                const newUSProvinceCodes = modifiedUSProvinceCodes.map((provinceCode) => {
                   return  {
                        text: provinceCode,
                        value: provinceCode
                    }
                })
                this.setState({
                    newUSProvinceCodes
                })
               
            },
            ko => { },
            this
        );
    }

    togglePropertyField({ items, fieldName, booleanValue, propertyName}) {
        const foundItem = items.find(item => item.id === fieldName);
        const foundItemIndex = items.findIndex(item => item.id === fieldName);
        foundItem[propertyName] = booleanValue;
        items[foundItemIndex] = foundItem;
    }

    resetCityProvinceZipField(items,newData, who, value, booleanValue) {
        items.forEach((item => {
            if (item.id === 'city') {
                item.value = '';
            }else if (item.id === 'province') {
                item.value = '';
            }else if (item.id === 'zip') {
                item.value = '';
            }
        }));
    }

    onAutocompleteCountryChange(who, value, countryCode) {
        let newData = {...this.state.modalColumn};
        newData.items[who[1]].value = value;
        const items = newData.items;

        const foundCountry = this.findCountry(value);
        const suggestedCountry = foundCountry;
        this.resetCityProvinceZipField(items, who, value);

        const findOrder = this.state.orders.find(item => item.orderNum === this.state.modalReference);

      
        if(countryCode === canadaCountryCode && findOrder.carrierName === UPSCourier ) {
            this.changeProvinceFieldType(newData, this.state.newCanadaProvinceCodes);
        } else if(countryCode === USCountryCode && findOrder.carrierName === UPSCourier) {
            this.changeProvinceFieldType(newData, this.state.newUSProvinceCodes);
        } else {
            this.changeProvinceFieldType(newData, [], "text");
        }

        this.setState({
            suggestedCountry : suggestedCountry,
            countryCode: countryCode,
            modalColumn: newData,
            suggestedCity: []
        });
        
    }

    onAutocompleteCityChange(who,  value ) {
        let newData = {...this.state.modalColumn};
        newData.items[who[1]].value = value;
        let countryCode = this.state.countryCode;

        if(countryCode.length === 0) {
            const countryName = newData.items[4].value
            const country = this.findCountry(countryName);
            countryCode = country[0]?.countryCode;
        }

        let suggested = [];
        if (value.length >= 2 && countryCode) {
            (autoCompleteForeignCitiesForCountry(this.uc.jwtToken, value,
                countryCode,
                response => {
                    response.forEach((el) => {
                        suggested.push({
                            id: el.id,
                            label: el.label,
                            labelShort:el.labelShort, 
                            cityName: el.cityName,
                            provinceCode: el.provinceCode,
                            zipCode: el.value
                        }); 
                    });
                    this.setState(prevState => {
                        let prevSuggestedCity = [...prevState.suggestedCity];
                        prevSuggestedCity = suggested;
                        return  { modalColumn: newData, suggestedCity: prevSuggestedCity }
                    })

                }));
        } 
        
        else {
            this.setState({ modalColumn: newData, suggestedCity: [] });
        }
    }
    
    onAutocompleteCitySelected(who, item) {
        let newData = {...this.state.modalColumn};
        const items = newData.items;
        items.forEach((fieldObject => {
            if (fieldObject.id === 'city') {
                fieldObject.value = this.getCityName(item);
                delete fieldObject.error;
            } else if (fieldObject.id === 'province') {
                fieldObject.value = this.getProvinceName(item);
                delete fieldObject.error;
            } else if (fieldObject.id === 'zip') {
                fieldObject.value = this.getZipCode(item);
                delete fieldObject.error;
            }
        }));
        this.checkForMandatoryFields(items, item);

        this.setState({ modalColumn: {...newData, items: items} });
    }

    checkForMandatoryFields(items, item) {
        if(!this.getProvinceName(item)) {
            this.togglePropertyField({
              items,
              fieldName: 'province',
              booleanValue: false,
              propertyName: "mandatory" 
            });
          } else {
              this.togglePropertyField({
                  items,
                  fieldName: 'province',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
  
          if(!this.getZipCode(item)) {
              this.togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: false,
                  propertyName: "mandatory" 
              });
            } else {
              this.togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
    }

    findCountry(countryName) {
        const foundCountry = this.state.countries
        .filter((el) => el.name.toLowerCase().includes(countryName.toLowerCase()))
        .map(el => {
            return {label: el.name, countryCode: el.code}
        });

        return foundCountry;
    }

    findCountryCode(countryName) {
        const foundCountry = this.state.countries
        .find((el) => el.name.toLowerCase() === countryName.toLowerCase())

        return foundCountry.code;
    }

    getCityName(cityObject) {
        const cityName = cityObject?.cityName;
        const labelShort = cityObject?.labelShort;
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return cityName;
        }


        if(zipCode && zipCode.length > 0) {
            return labelShort.split(zipCode)[0].trim()
        }

        if(!cityName) {
            return labelShort.trim();
        }

        if(zipCode && zipCode.length === 0) {
            return ''
        }
    }

    getProvinceName(cityObject) {
        const cityName = cityObject?.cityName;
        const provinceCode = cityObject?.provinceCode;
        if(cityName) {
            return provinceCode;
        }

        if(!cityName && provinceCode) {
            return provinceCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    getZipCode(cityObject) {
        const cityName = cityObject?.cityName;
        // const labelShort = cityObject?.labelShort;
        const provinceCode = cityObject?.provinceCode;
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return zipCode;
        }

        if(!cityName && zipCode) {
            return zipCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }


    validate(items) {
        let validation = [];
        for (let i = 0; i < items.length; i++) {
            let el = items[i];
            if (el.hasOwnProperty("validate") && el.mandatory) {
                validation.push({
                    fieldObject: el,
                    fieldName: el.id,
                    fieldValue: el.value,
                    fieldError: 'error',
                    validate: el.validate
                });
            }
        }
        return validate(validation);
    }


    filtersChange(ev) {
        let name = ev.target.name;
        let value = (ev.target.type == 'checkbox' || ev.target.type == 'checkbox') ? ev.target.checked : ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
    }

    getData(navigation) {
        try {

            this.props.loaderShow(0);
            this.loadOrders(navigation,ok => {
                this.props.loaderHide();

            },
            ko => {

                this.props.loaderHide();
            });

        }
        catch (e) {
            this.props.loaderHide();

        }
    }

    loadOrders(navigation, okFn, koFn) {
        const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
        const url = '/api/order/discarded-orders/' + navigation.pageNo.value + '/' + navigation.pageSize.value + "/" + filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
               
                let entries = this.buildEntries(response.data.result.orders);
                navigation.totalItems.value = response.data.result.totItems;

                this.setState({
                    entries: entries,
                    orders: response.data.result.orders,
                    navigation: navigation
                });
                if (typeof okFn === "function") okFn.call(this);
            },
            error => {
                this.props.loaderHide();
                const msg = this.le.messages[0];                
                this.props.popupErrorMessage(msg.messages);
                if (typeof koFn === "function") koFn.call(this, error);
            }
        );
    }

    postChangedOrder(orderNum, items, okFn, koFn) {
        try {
            this.props.loaderShow(0);
            let data = this.buildChangedOrderDto(orderNum, items);
            ajax(this, {
                method: 'post', url: '/api/order/post-discarded', headers: { Authorization: 'Bearer ' + this.uc.jwtToken },data:data },
                response => {

                    this.props.loaderHide();
                    if (typeof okFn === "function") okFn.call(this);
                },
                error => {
                    this.props.loaderHide();
                    const msg = this.le.messages[0];
                    let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage")
                        ? [error.errorMessage] : msg.messages;
                    this.props.popupErrorMessage(messages);
                    if (typeof koFn === "function") koFn.call(this, error);
                }
            );


        }
        catch (e)
        {
            this.props.loaderHide();

        }
    }

    deleteOrder(orderNum, okDel) {
        try {

            this.props.loaderShow(0);
            let orderNums = [orderNum];
            deleteOrders(orderNums, this.uc.jwtToken,
                ok => {

                    let popupExit = function () {

                        okDel.call(this);

                    };

                    this.props.loaderHide();
                    const msg = this.le.messages[1];
                    let obj = {
                        title: msg.captions[0],
                        width: "35%",
                        icon: "info",
                        messages: msg.messages,
                        buttons: [{
                            name: "ok", type: "confirm", width: "40%", text: "ok", class: "right",
                            click: popupExit
                        }]
                    };
                    this.props.popUp(obj);
                   
                },
                error => {
                    this.props.loaderHide();
                    const msg = this.le.messages[0];
                    let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage")
                        ? [error.errorMessage] : msg.messages;
                    this.props.popupErrorMessage(messages);
                });

        }
        catch (e) {
            this.props.loaderHide();

        }

    }

    buildChangedOrderDto(orderNum, items) {
        let data = {};

        data.orderNum = orderNum;
        data.orderRecipient = {};
        for (let i = 0; i < items.length; i++) {
            data.orderRecipient[items[i].id] = items[i].value; 
        }
        
        return data;
    }

    buildEntries(orders) {
        let entries = [];
        for (let i = 0; i < orders.length; i++) {
            let order = orders[i];
            let entry = [];
            entry.push(order.orderNum);
            entry.push(plainDate(order.orderDate));
            entry.push(order.carrierName);
            entry.push(order.customer);
            entry.push(order.errorMessage != null ? order.errorMessage : "");
            for (let i2 = 0; i2 < 8; i2++) {
                entry.push("");
            }
            if (order.orderRecipient != null) {
                let i2 = 5;
                entry[i2++] = order.orderRecipient.name;
                entry[i2++] = order.orderRecipient.surname;
                entry[i2++] = order.orderRecipient.address;
                entry[i2++] = order.orderRecipient.houseNo;
                entry[i2++] = order.orderRecipient.country;
                entry[i2++] = order.orderRecipient.city;
                entry[i2++] = order.orderRecipient.province;
                entry[i2++] = order.orderRecipient.zip;
                entry[i2++] = order.orderRecipient.note;
            }
            entries.push(entry);
        }

       
        return entries;
    }

    changeProvinceFieldType(modalColumns, optionState, type = "select") {
        const columnItems =  modalColumns.items;
        const foundItem = columnItems.find(item => item.id === 'province');
        const foundItemIndex = columnItems.findIndex(item => item.id === 'province');
        foundItem["type"] = type;
        foundItem["options"] = optionState;

        modalColumns.items[foundItemIndex] = foundItem;
        
        this.togglePropertyField({
            items: modalColumns.items,
            fieldName: 'province',
            booleanValue: true,
            propertyName: "mandatory" 
        });
    }


    changeAction(source) {
        let mdlCol = this.state.modalColumn;
        const idx = this.state.entries.findIndex((el) => (el[this.listKey] === source));
        const ds = this.state.entries[idx];
        
        this.modalDataMap.forEach((el) => {
            mdlCol.items[el[0]].value = ds[el[1]];
            mdlCol.items[el[0]].class = null;
        });


        const findOrder = this.state.orders.find(item => item.orderNum === source);
        const findOrderRecipient = findOrder.orderRecipient;
        const countryCode = this.findCountryCode(findOrderRecipient.country);
      
        if(countryCode === canadaCountryCode && findOrder.carrierName === UPSCourier ) {
            this.changeProvinceFieldType(mdlCol, this.state.newCanadaProvinceCodes);
        } else if(countryCode === USCountryCode && findOrder.carrierName === UPSCourier) {
            this.changeProvinceFieldType(mdlCol, this.state.newUSProvinceCodes);
        } else {
            this.changeProvinceFieldType(mdlCol, [], "text");

            this.setState({
                modalType: 1,
                modalReference: source,
                modalColumn: mdlCol,
                countryCode: countryCode,
                suggestedCity: [],
                carrierName: findOrder.carrierName
            });
            let item = {
                labelShort:findOrderRecipient.city, 
                cityName: findOrderRecipient.city,
                provinceCode: findOrderRecipient.province,
                zipCode: findOrderRecipient.zip
            }
            const items = mdlCol.items;
            this.checkForMandatoryFields(items, item);
        }
    }

    removeAction(source) {       
        let okFn = this.deleteOrder.bind(this, source,
            ok => {

                this.getData(this.state.navigation);

            }
        );
        showPopup(this.props.popUp, this.le.popup.deletePopup.title, 'question',
            this.le.popup.deletePopup.message, this.le.popup.confirmText,
            this.le.popup.cancelText,
            okFn,
            (ev, type, name) => { }
        );
    }

    

    listChange(ev, name, value, source) {
        let managers = JSON.parse(JSON.stringify(this.state.managers)), entries = JSON.parse(JSON.stringify(this.state.entries));
        const row = (source === "##header##" ? -1 : entries.findIndex((el) => (el[this.listKey] === source))), col = this.dataIndexes.find((el) => (el.name === name));
        if (col.manage > 0) {
            if (name === "main" && row === -1) {
                managers = managers.map(function (el) {
                    el[col.idx] = value;
                    return el;
                });
            }
            else managers[row + 1][col.idx] = value;
            this.setState({ managers: managers });
        }
        else {
            entries[row][col.idx] = value;
            this.setState({ entries: entries });
        }
    }

    listClick(ev, name, value, source) {
        const targetName = ev.target.name;
        if (targetName == 'modify') {
            this.changeAction(value);
        }
        else {
            this.removeAction(value);

        }
    }

    modalChange(ev, who, value) {
        let mdlCol = this.state.modalColumn;
        mdlCol.items[who[1]].value = value;
        if(Object.hasOwn(mdlCol.items[who[1]], "error")) {
            delete mdlCol.items[who[1]].error;
        }
        this.setState({ modalColumn: mdlCol });
    }
   
    modalClick(ev, data) {
        
        if (data) {
            let orderNum = this.state.modalReference;
            let modalData = this.state.modalColumn.items;

            if (!this.validate(modalData)) {
                this.setState({ modalColumn: this.state.modalColumn });
                return;
            }

            this.postChangedOrder(orderNum, modalData, ok => {
                this.setState({ modalType: 0, modalReference: null });
                this.props.loaderHide();
                let me = this;
                let popupExit = function () {
                    me.getData(me.state.navigation);
                };

                
                const msg = this.le.messages[2];
                let obj = {
                    title: msg.captions[0],
                    width: "35%",
                    icon: "info",
                    messages: msg.messages,
                    buttons: [{
                        name: "ok", type: "confirm", width: "40%", text: "ok", class: "right",
                        click: popupExit
                    }]
                };
                this.props.popUp(obj);


            },
            ko => {
            });

        }
        else {
            this.setState({ modalType: 0, modalReference: null });
        }
            
    }

    render() {
        let modal;
        if(this.state.modalType == 1) {
            let suggestedOptions = {...this.state.modalColumn};
            suggestedOptions.items[4].options = this.state.countries;   
            suggestedOptions.items[5].options = this.state.suggestedCity;

            const le = this.le.update, buttons = [<UIButton key={uuidv4()} className = "confirm" text={le.button } onClick = {(ev) => (this.modalClick(ev, true))} />];
            modal = <UIPopup title={le.title} buttons={buttons} onCancel={((ev) => (this.modalClick(ev, false)))}>
                <div className="flex-panel">
                    <InputColumn 
                        column={this.state.modalReference}
                        data={this.state.modalColumn}
                        onChange={this.modalChange}
                        onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                        // onAutocompleteCountrySelected={this.onAutocompleteCountrySelected}
                        onAutocompleteChange={this.onAutocompleteCityChange}
                        onAutocompleteSelected={this.onAutocompleteCitySelected}
                        />
                </div>
            </UIPopup>;
        }



        let filters = {};
        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);


        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />;
                case "checkbox":
                    return <UICheckbox key={key} name={key} onChange={this.filtersChange} value={val.value} label={this.le.filters.items[key]} />;
                default:
                    return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);


        return <div className="page-order-history">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersListDiscarded} />

            <UIFilterPanel>
                {pageFilters}
            </UIFilterPanel>

            <div className="page-content">

                <UIDataTable header={this.header} entries={this.state.entries} listKey={this.listKey} managers={this.state.managers} navigation={this.state.navigation} />

            </div>
            {modal}
        </div>;
    }
}


export class Bordero extends React.Component {
    constructor(props) {
        super(props);

        this.filtersChange = this.filtersChange.bind(this);
        this.downloadBordero = this.downloadBordero.bind(this);
        this.listChange = this.listChange.bind(this);
        this.getData = this.getData.bind(this);

        this.le = Languages.Bordero[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.configs = {
            filters: {
                dateFrom: { type: "date", width: "10%" },
                dateTo: { type: "date", width: "10%" },
                warehouse: { type: "text", width: "17%" },
                courier: { type: "text", width: "16%" },
                downloaded: {
                    type: "select",
                    options: [
                        { text: "Tutti gli stati", value: "" },
                        { text: this.le.borderoDownloadedStatuses[0], value: 0 },
                        { text: this.le.borderoDownloadedStatuses[1], value: 1 }
                    ]}
            }
        };


        let filters = {};
        Object.entries(this.configs.filters).map(([key, val], idx) => {            
            filters[key] = "";
        });
        

        this.header = [{
                generic: { manage: 1, default: false, name: 'main', width: 13, change: this.listChange, click: null },
                caption: { type: 'checkbox', colClass: 'right', itemClass: null, textClass: 'bold', value: this.le.list[5] },
                element: { type: 'checkbox', colClass: 'right', itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'file', width: 22, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'store', width: 11, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'courier', width: 8, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'date', width: 8, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[4] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'status', width: 8, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[5] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }];
        this.listKey = 5;

        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));
        this.appliedFilters = filters;
        this.state = {
            filters: filters,
            entries: props.entries,
            orders: [],
           
            navigation: this.props.navigation,
            managers: Array(props.entries.length + 1).fill().map((el) => (this.defaultManager.slice()))
        };
    }
    buildEntries(orders) {

        let entries = [];
        for (let i = 0; i < orders.length; i++) {
            let order = orders[i];
            let entry = [];
            entry.push(order.fileLabel != null ? order.fileLabel:"");
            entry.push(order.pickupAddress);
            entry.push(order.carrier);
            entry.push(plainDate(order.orderDate));
            entry.push(this.le.borderoDownloadedStatuses[order.downloaded ? 1 : 0]);
            entry.push(order.fileName);

            entries.push(entry);
        }


        return entries;
    }
    findSelectedOrders(setDownloaded) {
        let orders = [];
        let entries = [];

        for (let i = 0; i < this.state.entries.length; i++) {        
            let e = this.state.entries[i];
            if (this.state.managers[i + 1][0]) {
                // checked
                orders.push(e[this.listKey]);

                if(setDownloaded)
                    e[4] = this.le.borderoDownloadedStatuses[1];
            }

            if (setDownloaded)
                entries.push(e);
        }

        if (setDownloaded)
            this.setState({
                entries: entries
            });


        /*for (var i = 1; i < this.state.managers.length; i++) {
            if (this.state.managers[i][0])  // is the checkbox checked?
            {
                if ((i - 1) < this.state.entries.length) {
                    let orderNum = this.state.entries[i - 1][this.listKey];
                    orders.push(orderNum);
                }
            }
        }*/
        return orders;
    }
    getData(navigation) {
        this.props.loaderShow(1);
        const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
        const url = '/api/order/bordero/' + navigation.pageNo.value + '/' + navigation.pageSize.value + "/" +
            filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {

                this.props.loaderHide();
                let entries = this.buildEntries(response.data.result.orders);
                navigation.totalItems.value = response.data.result.totItems;
                this.setState({
                    entries: entries,
                    orders: response.data.result.orders,
                    managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                    navigation: navigation
                });
               
            },
            error => {
                this.props.loaderHide();
                const msg = this.le.messages[0];
                this.props.popupErrorMessage(msg.messages);
            }
        );
    }
    downloadFiles(listOfIds) {
        if (listOfIds == undefined || listOfIds == null || listOfIds.length==0)
            return;

        let url = "/api/filemanager/order-doc/bordero"; 
        downloadFilePost(url,listOfIds, this.uc.jwtToken, error => {


            let msg = this.le.messages[0];
            if (error != undefined && error != null && error.hasOwnProperty("response")
                && error.response.hasOwnProperty("status") && error.response.status == 404)
                msg = this.leMain.messages.fileNotFound;                
            this.props.popupErrorMessage(msg.messages);
        });
    }



    componentDidMount() {
      
        try {
            let navigation = getNavigation(this.getData, this.leMain.navigation);
            this.getData(navigation);
        }
        catch (e)
        {
        }
    }


    filtersChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = JSON.parse(JSON.stringify(newFilters));

            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
        this.setState({ filters: newFilters });
    }

    downloadBordero(ev, data) {
        let selectedOrders = this.findSelectedOrders(true);

        try {
            if (selectedOrders.length > 0) {
                this.downloadFiles(selectedOrders);
            }
            else
                this.props.popupErrorMessage(this.le.noSelectedBordero);
        }
        catch (e)
        {
        }
    }

    listChange(ev, name, value, source) {
        let managers = JSON.parse(JSON.stringify(this.state.managers)), entries = JSON.parse(JSON.stringify(this.state.entries));
        const row = (source === "##header##" ? -1 : entries.findIndex((el) => (el[this.listKey] === source))), col = this.dataIndexes.find((el) => (el.name === name));

        

        if (col.manage > 0) {
            if (name === "main" && row === -1) {
                managers = managers.map(function (el) {
                    el[col.idx] = value;
                    return el;
                });
            }
            else managers[row + 1][col.idx] = value;


            if (managers.filter(function (el) { return el[0] == true }).length==1 && managers[0][0])
            {
                managers[0][0] = false;
            }

            this.setState({ managers: managers });
        }
        else {
            entries[row][col.idx] = value;
            this.setState({ entries: entries });
        }
    }


    render() {
        let le = this.le;
        let pageFilters = Object.entries(this.configs.filters).map(([key, val], idx) => {
            if (val.type == "select")
                return <UISelect key={key} name={key} options={val.options} value={this.state.filters[key]} onChange={this.filtersChange} />
            else
                return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={this.state.filters[key]} hint={le.filters.items[key]} />;
        });
        pageFilters.push(<UIDownload key="downlaod" title={this.le.button} onClick={this.downloadBordero} />);

        return <div className="page-bordero">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersBordero} />
            <div className="page-content">

                <UIFilterPanel>
                    {pageFilters}
                </UIFilterPanel>

                <UIDataTable header={this.header} entries={this.state.entries} listKey={this.listKey} managers={this.state.managers} navigation={this.state.navigation} />




            </div>
        </div>;        
    }
}


export class OrderHistory extends React.Component {
    constructor(props) {
        super(props);
        this.history = props.history;
        this.listClick = this.listClick.bind(this);
        this.filtersChange = this.filtersChange.bind(this);
        this.getData = this.getData.bind(this);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.OrderHistory[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.header = [
            {
                generic: { manage: 0, name: 'orderNo', width: 14, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'date', width: 12, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'courier', width: 11, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'customer', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'services', width: 12, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[4] },
                element: { type: 'component', colClass: null, itemClass: 'services-cell', options: null }
            },
            {
                generic: { manage: 1, default: null, name: 'actions', width: 13, change: null, click: this.listClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[4] },
                element: { type: 'buttons-group', colClass: null, itemClass: ['modify','return', 'delete modify'], options: this.le.listButtons }
            }];
        this.listKey = 0;

        this.configs = {
            filters: {
                orderNum: { type: "text", width: "20%" },
                recipient: { type: "text", width: "20%" }
            }
        };

        let filters = {};
        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });
        this.appliedFilters = filters;

        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));

        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.state = {
            entries: [],
            managers: Array(1).fill().map((el) => (this.defaultManager.slice())),
            filters: filters,
            navigation: navigation,
            modal: null
        };
    }

    filtersChange(ev) {
        let name = ev.target.name;
        let value = (ev.target.type == 'checkbox' || ev.target.type == 'checkbox') ? ev.target.checked : ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);                                                                       
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
    }

    getData(navigation) {

        const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
        const url = '/api/order/history/' + navigation.pageNo.value + '/' + navigation.pageSize.value + "/" + filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                const entries = response.data.result.orders.map(el => {
                    // qui preparo la cella con le icone
                    const servicesCell = (
                        <div className="services-icons">
                            {el.isEnsured && <img src="../images/icon-assurance.png" alt="Assicurato" title="Assicurazione" width={18} height={18} style={{ marginRight: 10 }} />}
                            {el.isCashOnDelivery && <img src="../images/icon-contrassegno.png" alt="Contrassegno" title="Contrassegno" width={18} height={18} />}
                        </div>
                    );
                    // qui ritorno la riga completa, sostituendo la colonna insurance con servicesCell
                    return [
                        el.orderNum,
                        plainDate(el.orderDate),
                        el.carrierSign,
                        el.customer,
                        servicesCell,
                        {
                            id: el.id,
                            isDisabled: (el.isReturned || el.isForeignCountry)
                        }
                    ];
                });
                navigation.totalItems.value = response.data.result.totItems;
                this.setState({
                    entries: entries,
                    managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                    navigation: navigation
                });
            },
            error => {
                this.props.popupErrorMessage(error.message);
            }
        );
    }


    orderLabelAction(orderNum) {
        try {
            let listOfOrdersNum = [orderNum];
            downloadOrderLabels(this.uc.jwtToken,listOfOrdersNum, error => {
                let msg = this.le.messages[0];
                if (error != undefined && error != null && error.hasOwnProperty("response")
                    && error.response.hasOwnProperty("status") && error.response.status == 404)
                    msg = this.leMain.messages.fileNotFound;
                this.props.popupErrorMessage(msg.messages);
            });
        }
        catch (e) {
            const msg = this.le.messages[0];
            this.props.popupErrorMessage(msg.messages);
        }
    }

    modalClick(ev, isButtonConfirm, orderRow) {
        if (isButtonConfirm) {
            let orderId = this.state.entries[orderRow - 1].pop();
            this.history.push(`/orders-2?orderId=${orderId.id}`)
        } else {
            this.setState({ modal: null });
        }
    }

    returnOrderAction(orderNum, orderRow) {
        let buttons = [
            <UIButton key={uuidv4()}
                className = "cancel"
                text={this.le.popup.cancelText }
                onClick = {(ev) => (this.modalClick(ev, false))} />,
            <UIButton key={uuidv4()}
                className = "confirm"
                text={this.le.popup.returnPopup.confirmText }
                onClick = {(ev) => (this.modalClick(ev, true, orderRow))} />,
            ];

        this.setState({
            modal: <UIPopup title={this.le.popup.returnPopup.title} buttons={buttons} onCancel={((ev) => (this.modalClick(ev, false)))}>
                <div className="">
                    {this.le.popup.returnPopup.message} <strong>{orderNum}</strong>?
                </div>
            </UIPopup>
        });
    }

    deleteOrderAction(orderNum) {
         let okFn = () => {
            try {
                this.props.loaderShow(0);
                let listOfOrder = [orderNum];
                deleteOrders(listOfOrder, this.uc.jwtToken,
                    ok => {
                        let me = this;
                        let reload = function () {
                            me.getData(me.state.navigation);
                        }
    
                        this.props.loaderHide();
                        const msg = this.le.messages[1];
                        let obj = {
                            title: msg.captions[0],
                            width: "35%",
                            icon: "info",
                            messages: msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: reload }]
                        };
                        this.props.popUp(obj);
                        
                    },
                    ko => {
                        this.props.loaderHide();
                        const msg = this.le.messages[0];
                        this.props.popupErrorMessage(msg.messages);
                    });
    
            }
            catch (e) {
                this.props.loaderHide();
                const msg = this.le.messages[0];
                this.props.popupErrorMessage(msg.messages);
            }
         }

        showPopup(this.props.popUp, this.le.popup.deletePopup.title, 'question',
                `${this.le.popup.deletePopup.message} <strong>${orderNum}</strong>?`, this.le.popup.confirmText,
                this.le.popup.cancelText,
                okFn,
                () => { }
        );
        
       
    }

    componentDidMount() {
        this.getData(this.state.navigation);
    }

    listClick(ev, row, value) {
        const targetName = ev.target.name;
        try {
            switch (targetName) {
                case 'modify':
                    this.orderLabelAction(value);
                    break;
                case 'return':
                    this.returnOrderAction(value, row);
                    break;
                default:
                    this.deleteOrderAction(value);
                    break;
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    render() {
        let filters = {};
        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);

        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />;
                case "checkbox":
                    return <UICheckbox key={key} name={key} onChange={this.filtersChange} value={val.value} label={this.le.filters.items[key]} />;
                default:
                    return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);
        

        return <div className="page-order-history">
            <PageTitle icon="../images/mainMenu/Orders.png" title={Languages.getSection('Main').menuLabels.ordersHistory} />

            <UIFilterPanel>
                {pageFilters}
            </UIFilterPanel>

            <div className="page-content">
                <UIDataTable
                    header={this.header}
                    entries={this.state.entries}
                    listKey={this.listKey}
                    managers={this.state.managers}
                    navigation={this.state.navigation} />
            </div>
            {this.state.modal}
        </div>;
    }
}


export class OrdersReturned extends React.Component {
    constructor(props) {
        super(props);

        this.listClick = this.listClick.bind(this);
        this.filtersChange = this.filtersChange.bind(this);
        this.getData = this.getData.bind(this);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.OrdersReturned[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        this.header = [
            {
                generic: { manage: 0, name: 'returnedOrderNo', width: 14, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'date', width: 12, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'courier', width: 11, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'customer', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'orderNo', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list[4] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 1, default: null, name: 'actions', width: 13, change: null, click: this.listClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list[5] },
                element: { type: 'buttons-group', colClass: null, itemClass: ['modify'], options: this.le.listButtons }
            }];
        this.listKey = 0;

        this.configs = {
            filters: {
                orderNum: { type: "text", width: "20%" },
                recipient: { type: "text", width: "20%" }
            }
        };

        let filters = {};
        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });
        this.appliedFilters = filters;

        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));

        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.state = {
            entries: [],
            managers: Array(1).fill().map((el) => (this.defaultManager.slice())),
            filters: filters,
            navigation: navigation,
        };
    }

    filtersChange(ev) {
        let name = ev.target.name;
        let value = (ev.target.type == 'checkbox' || ev.target.type == 'checkbox') ? ev.target.checked : ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
    }

    getData(navigation) {

        const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
        const url = '/api/order/returned-orders/' + navigation.pageNo.value + '/' + navigation.pageSize.value + "/" + filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                const entries = response.data.result.orders.map(el => ([
                    el.orderNum, plainDate(el.orderDate), el.carrierSign, el.customer, el.orderNumReturned
                ]));
                navigation.totalItems.value = response.data.result.totItems;
                
                this.setState({
                    entries: entries,
                    managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                    navigation: navigation
                });
            },
            error => {
                this.props.popupErrorMessage(error.message);
            }
        );
    }


    orderLabelAction(orderNum) {
        try {
            let listOfOrdersNum = [orderNum];
            downloadOrderLabels(this.uc.jwtToken,listOfOrdersNum, error => {
                let msg = this.le.messages[0];
                if (error != undefined && error != null && error.hasOwnProperty("response")
                    && error.response.hasOwnProperty("status") && error.response.status == 404)
                    msg = this.leMain.messages.fileNotFound;
                this.props.popupErrorMessage(msg.messages);
            });
        }
        catch (e) {
            const msg = this.le.messages[0];
            this.props.popupErrorMessage(msg.messages);
        }
    }

    componentDidMount() {
        this.getData(this.state.navigation);
    }

    listClick(ev, row, value) {
        const targetName = ev.target.name;
        try {
            switch (targetName) {
                case 'modify':
                    this.orderLabelAction(value);
                    break;
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    render() {
        let filters = {};
        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);

        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />;
                case "checkbox":
                    return <UICheckbox key={key} name={key} onChange={this.filtersChange} value={val.value} label={this.le.filters.items[key]} />;
                default:
                    return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);


        return <div className="page-order-history">
            <PageTitle icon="../images/mainMenu/returnedOrders.png" title={Languages.getSection('Main').menuLabels.ordersReturned} />

            <UIFilterPanel>
                {pageFilters}
            </UIFilterPanel>

            <div className="page-content">
                <UIDataTable
                    header={this.header}
                    entries={this.state.entries}
                    listKey={this.listKey}
                    managers={this.state.managers}
                    navigation={this.state.navigation} />
            </div>
        </div>;
    }
}